/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsReturnStep: {
  name: 'return-step';
  data: string;
} = {
  name: 'return-step',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill-rule="evenodd" clip-rule="evenodd" d="M11.5 3a.5.5 0 0 0-.82-.384L5.5 6.932V3a.5.5 0 1 0-1 0v10a.5.5 0 0 0 1 0V9.068l5.18 4.316A.5.5 0 0 0 11.5 13V3Zm-1 8.932L5.781 8 10.5 4.068v7.864Z" fill="currentColor"/></svg>`,
};
